import { categoryMap, OrderStatus, ServiceType } from "@/model/Base";

export function titlename(value: any) {
  //   let __self = this;
  let matched = categoryMap[value.ClientOrderStatus];
  let name = matched.CategoryTitle || matched.CategoryName;
  if (value.ClientOrderStatus == OrderStatus.WaitPayment && value.ClientStatusName != name) {
    return value.ClientStatusName;
  }
  return name;
}
export function filterFeatureCodes(featurecode: string, orderServiceType: number, item: any) {
  // let __self = this;
  if (!featurecode || !orderServiceType || !item) {
    return "";
  }
  var codes = [];
  let upperCodes = featurecode.toLocaleUpperCase().split(",");
  for (var i = 0; i < upperCodes.length; i++) {
    var code = upperCodes[i];
    if (code == "AMENDING") {
      if (orderServiceType == ServiceType.HotelService) {
        codes.push("退房处理中");
      } else if (orderServiceType == ServiceType.TourService) {
        codes.push("退团处理中");
      } else {
        codes.push("退票处理中");
      }
    }
    if (code == "AMEND") {
      if (orderServiceType == ServiceType.HotelService) {
        codes.push("有退房");
      } else if (orderServiceType == ServiceType.TourService) {
        codes.push("有退团");
      } else {
        codes.push("有退票");
      }
    }

    if (code == "FULLAMENDADUITING" || code == "AMENDADUITING") {
      codes.push("退票审核中");
    }
    if (code == "FULLAMENDREFUNDING" || code == "AMENDREFUNDING") {
      codes.push("退票退款中");
    }

    if (code == "FULLCHANGEADUITING" || code == "CHANGEADUITING") {
      codes.push("改签审核中");
    }
    if (code == "FULLCHANGEETDZING" || code == "CHANGEETDZING") {
      codes.push("改签出票中");
    }

    if (code == "CHANGEING") {
      codes.push("改签处理中");
    }
    if (code == "CHANGE") {
      codes.push("有改签");
    }
    if (code == "FULLCHANGE") {
      codes.push("全部改签");
    }
    if (code == "FULLAMEND") {
      if (orderServiceType == ServiceType.HotelService) {
        codes.push("全部退房");
      } else codes.push("全部退票");
    }
    if (code == "FULLCHANGEING") {
      codes.push("全部改签中");
    }
    if (code == "FULLAMENDING") {
      if (orderServiceType == ServiceType.HotelService) {
        codes.push("全部退房中");
      } else {
        codes.push("全部退票中");
      }
    }
  }
  var odrCodes = "";

  var str = titlename(item);

  if (codes.length > 0) {
    odrCodes = "(" + codes.join(",") + ")";
  }
  if (odrCodes.indexOf("全部") > -1) {
    return codes.join(",");
  }
  //   this.orderStatus = str + odrCodes;
  return str + odrCodes;
}

export function parseOrder(item: any) {
  if (JSON.stringify(item) === "{}" || typeof item == "string") {
    return;
  }
  let results: any = [];
  let ConsumerZoneNames = item.ConsumerZoneName.split(/\n|&|,/g);
  let FinishedZoneNames = item.FinishedZoneName.split(/\n|&|,/g);
  let ConsumerAddress = item.ConsumerAddress.split(/\n|&|,/g);
  let FinishedAddress = (item.FinishedAddress || "").split(/\n|&|,/g);
  let FinishedDates = item.FinishedDate.split(/\n|&|,/g);
  let ConsumerDates = item.ConsumerDates.split(/\n|&|,/g);
  let ProduceCodes = item.ProduceCode.split(/\n|&|,/g);
  let LevelNames = item.LevelName.split(/\n|&|,/g);
  let BatchCodes = item.BatchCode.split(/\n|&|,/g);
  let ProduceNames = item.ProduceName.split(/\n|&|,/g);
  let ProductNames = item.ProductName.split(/\n|&|,/g);
  if (item.ShareAirwayCode) {
    var ShareAirwayCodes = item.ShareAirwayCode.split(/\n|&|,/g);
  }
  if (item.ShareFlightNo) {
    var ShareFlightNos = item.ShareFlightNo.split(/\n|&|,/g);
  }

  for (let i = 0; i < ConsumerZoneNames.length; i++) {
    let result = {};
    results.push(result);
  }
  for (let j = 0; j < results.length; j++) {
    results[j].orderSource = item;
    results[j].ServiceType = item.ServiceType;
    results[j].ProductCount = item.ProductCount;
    results[j].ProduceName = ProduceNames[j];
    results[j].ProductName = ProductNames[j];
    results[j].LevelName = LevelNames[j];
    results[j].BatchCode = BatchCodes[j];
    results[j].ProduceCode = ProduceCodes[j];
    results[j].ConsumerZoneName = ConsumerZoneNames[j];
    results[j].FinishedZoneName = FinishedZoneNames[j];
    results[j].ConsumerAddress = ConsumerAddress[j];
    results[j].FinishedAddress = FinishedAddress[j];

    results[j].FinishedDate = FinishedDates[j];
    results[j].ConsumerDate = ConsumerDates[j];
    if (ShareAirwayCodes) {
      results[j].ShareAirwayCode = ShareAirwayCodes[j];
    }
    if (ShareFlightNos) {
      results[j].ShareFlightNo = ShareFlightNos[j];
    }
  }
  return results;
}
